import styled from "styled-components";

export const Container = styled.div`
  max-width: 1600px;
  width: 100%;

  display: grid;
  grid-template-areas: "ORDERMAIN ORDERDETAILS";

  gap: 1.5rem;

  @media (max-width: 1200px) {
    grid-template-columns: 100%;
    grid-template-areas:
      "ORDERMAIN"
      "ORDERDETAILS";
  }
`;
